module.exports = __webpack_public_path__ + "img/garansi-uang-kembali.4f290bd1.svg";